<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        {{aLang.c_list}} {{aLang.sdrd_title}}
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <div class="text-left">
          <b-collapse v-bind:visible="mData.tableRules.showFormSearch" id="myFormSearch">
            <b-card>
              <el-form
                ref="myForm"
                label-position="top"
                @submit.native.prevent
                :model="mData.tableRules.dataSearch.value"
                :rules="mData.tableRules.dataSearch.valid"
              >
                <b-row>
                  <b-col md="3">
                    <el-form-item :label="aLang.sdrd_evaluate">
                      <el-input type="number" v-model="mData.tableRules.dataSearch.value.gia_tri" clearable></el-input>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item :label="aLang.sdrd_created_time" prop="thoi_diem_tao">
                      <el-date-picker
                        type="date"
                        :format="aElement.datepicker.formatDate"
                        :valueFormat="aElement.datepicker.valueFormat"
                        v-model="mData.tableRules.dataSearch.value.thoi_diem_tao"
                        :placeholder="aElement.datepicker.placeholderDate"
                        clearable
                      ></el-date-picker>
                    </el-form-item>
                  </b-col>
                </b-row>
                <el-form-item class="text-center mb-0">
                  <el-button
                    type="info"
                    native-type="submit"
                    v-ladda
                    plain
                    @click="fn_tableSearch()"
                  >{{aLang.c_search}}</el-button>
                </el-form-item>
              </el-form>
            </b-card>
          </b-collapse>
        </div>
        <b-row>
          <b-col md="12">
            <div class="text-right mb-2">
              <el-button
                @click="fn_tableShowFormSearch()"
                type="info"
                plain
              >{{aLang.c_showHideSearch}}</el-button>
              <!-- <el-button @click="fn_handle('create')" type="info" plain>{{aLang.c_create}}</el-button> -->
              <!-- <el-button @click="fn_handle('goBack')" type="info" plain>{{aLang.c_back}}</el-button> -->
            </div>
          </b-col>
        </b-row>

        <el-table
          :data="mData.tableRules.data"
          border
          @selection-change="fn_tableSelectionChange"
          @sort-change="fn_tableSortChange"
          max-height="440"
          style="width: 100%"
          :default-sort="{prop: mData.tableRules.defaultSort[0], order: mData.tableRules.defaultSort[1]}"
        >
          <el-table-column type="selection" width="40" v-if="mData.tableRules.allowSelect"></el-table-column>
          <el-table-column
            prop="ten_nguoi_danh_gia"
            :label="aLang.sdrd_assessor"
            min-width="200"
            width="200"
          ></el-table-column>
          <el-table-column
            prop="doi_tuong_danh_gia_id"
            :label="aLang.sdrd_assessment_object"
            min-width="200"
          >
              <template slot-scope="scope">
              {{scope.row.ten_doi_tuong_danh_gia}}
            </template>
          </el-table-column>
          <el-table-column
            prop="gia_tri"
            :sortable="mData.tableRules.allowSorting"
            :label="aLang.sdrd_evaluate"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              {{fn_formatterNumber(scope.row.gia_tri,1)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="thoi_diem_tao"
            :sortable="mData.tableRules.allowSorting"
            :label="aLang.sdrd_created_time"
            :formatter="fn_formatterDatetime"
            width="150"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="thoi_diem_check_in"
            :label="aLang.sdrd_checkIn_time"
            :formatter="fn_formatterDatetime"
            width="150"
            align="center"
          ></el-table-column>

          <el-table-column :label="aLang.c_action" align="center" width="150px">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="fn_handle('detail',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_detail"
              >
                <i class="fa fa-eye"></i>
              </el-button>
              <!-- <el-button
                size="mini"
                @click="fn_handle('update',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_update"
              >
                <i class="icon-pencil icons"></i>
              </el-button>-->
              <!-- <el-button
                size="mini"
                @click="fn_handle('delete',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_delete"
                v-if="aRole('Admin,Officer')"
              >
                <i class="icon-trash icons"></i>
              </el-button> -->
            </template>
          </el-table-column>
        </el-table>

        <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
          <div class="col-md-4">
            <div
              v-if="mData.tableRules.allowSelect"
            >{{aLang.c_select}}: {{mData.tableRules.recordSelected.length}}</div>
          </div>
          <div class="col-md-8 text-right">
            <el-pagination
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
              :page-sizes="mData.tableRules.lengthMenu"
              :page-size="mData.tableRules.limit"
              :current-page="mData.tableRules.page"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="mData.tableRules.total"
              :pager-count="5"
            ></el-pagination>
          </div>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import ExtensionService from "../../../service/ExtensionService";
import DanhGiaDDATDetailModel from "./DanhGiaDDATDetailModel";
import DanhGiaLogApi from "../../../moduleApi/DanhGiaLogApi";
import KhachDuLichApi from "../../../moduleApi/KhachDuLichApi";
import TourApi from "../../../moduleApi/TourApi";
import HuongDanVienApi from "../../../moduleApi/HuongDanVienApi";
import DichVuChatLuongCaoApi from "../../../moduleApi/DichVuChatLuongCaoApi";
import DiemDenAnToanApi from "../../../moduleApi/DiemDenAnToanApi";
import CoSoLuuTruApi from "../../../moduleApi/CoSoLuuTruApi";
import CheckinDDATApi from "../../../moduleApi/CheckinDDATApi";

export default {
  data() {
    return {
      aRole: MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        moduleName: "DanhGiaDDATDetail", //requied
        urlImg: ExtensionService.urlImg,
        tableRules: MethodService.copyObject(DanhGiaDDATDetailModel.tableRules),
        dataDefault: {
          listNguoiDanhGia: [],
          listNguoiDanhGiaHDV: [],
          listDoiTuongDanhGia: [],
          listLuotCheckin: []
        }
      }
    };
  },

  methods: {
    //get list table
    async fn_initTable() {
      //Chỉ lấy theo các hdv đã dẫn cho tour
      // let resHDV = await HuongDanVienApi.getListHuongDanVienDaDan();
      // let huongDanVienIds = [];
      // huongDanVienIds = MethodService.findListItemDifferent(resHDV.result, "id");
      // this.mData.tableRules.filters="doi_tuong_danh_gia_id:in:"+huongDanVienIds.join(",");
      //
      let dataFilter = {
        filters: this.mData.tableRules.filters
      };

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }

      if (this.mData.tableRules.showUrl) {
        this.$router.replace({
          name: "Admin-" + this.mData.moduleName + "-list",
          query: {
            limit: this.mData.tableRules.limit,
            page: this.mData.tableRules.page,
            sort: this.mData.tableRules.sort,
            filters: this.mData.tableRules.filters,
            showFormSearch: this.mData.tableRules.showFormSearch
          }
        });
      }

      let res = await DanhGiaLogApi.list(dataFilter);

      //get List
      let nguoiDanhGias = [];
      let doiTuongDanhGias = [];
      let luotCheckins = [];

      luotCheckins = MethodService.findListItemDifferent(
        res.result,
        "check_in_id"
      );

      nguoiDanhGias = MethodService.findListItemDifferent(
        res.result,
        "nguoi_danh_gia_id"
      );

      doiTuongDanhGias = MethodService.findListItemDifferent(
        res.result,
        "doi_tuong_danh_gia_id"
      );

      let resLuotCheckinApi = await CheckinDDATApi.list({
        limit: luotCheckins.length,
        filters: "id:in:" + luotCheckins.join(",")
      });
      let resNguoiDanhGiaKDLApi = await KhachDuLichApi.list({
        limit: nguoiDanhGias.length,
        filters: "id:in:" + nguoiDanhGias.join(",")
      });
      let resNguoiDanhGiaHDVApi = await HuongDanVienApi.list({
        limit: nguoiDanhGias.length,
        filters: "id:in:" + nguoiDanhGias.join(",")
      });


      // let resDoiTuongDanhGiaApi =await KhachDuLichApi.list({ limit: khachDuLichIds.length, filters: "id:in:" + doiTuongDanhGias.join(",")});
      let resDoiTuongDanhGiaApi = await DiemDenAnToanApi.list({
        limit: doiTuongDanhGias.length,
        filters: "id:in:" + doiTuongDanhGias.join(",")
      });

      this.mData.dataDefault.listNguoiDanhGia = resNguoiDanhGiaKDLApi.result;
      this.mData.dataDefault.listNguoiDanhGiaHDV = resNguoiDanhGiaHDVApi.result;

      this.mData.dataDefault.listDoiTuongDanhGia = resDoiTuongDanhGiaApi.result;
      this.mData.dataDefault.listLuotCheckin = resLuotCheckinApi.result;
      //end

      this.mData.tableRules.data = this.changeData(res.result);
      this.mData.tableRules.total = res.meta.total;
      this.mData.tableRules.page = res.meta.offset / res.meta.limit + 1;
      if (
        this.mData.tableRules.offset == res.meta.total &&
        this.mData.tableRules.offset != 0
      ) {
        this.mData.tableRules.offset = 0;
        this.mData.tableRules.page = 1;
        this.fn_initTable();
      }
    },

    //xử lý dữ liệu đầu ra
    changeData(data) {
      $.each(data, (index, item) => {
        let nguoiDanhGia = this.mData.dataDefault.listNguoiDanhGia.find(
          element => {
            return element.id == item.nguoi_danh_gia_id;
          }
        );
        if (nguoiDanhGia) {
          if(nguoiDanhGia.ho_ten && nguoiDanhGia.ho_ten.ho_ten && nguoiDanhGia.ho_ten.ho_ten.trim() != ""){
            item.ten_nguoi_danh_gia = nguoiDanhGia.ho_ten.ho_ten;
          }else{
            item.ten_nguoi_danh_gia = "Chưa có thông tin";
          }
          
        } else {
          let nguoiDanhGiaHDV = this.mData.dataDefault.listNguoiDanhGiaHDV.find(
            element => {
              return element.id == item.nguoi_danh_gia_id;
            }
          );
          if (nguoiDanhGiaHDV) {
            item.ten_nguoi_danh_gia = nguoiDanhGiaHDV.ho_ten.ho_ten;
          } else {
            item.ten_nguoi_danh_gia = "";
          }
        }

        let doiTuongDanhGia = this.mData.dataDefault.listDoiTuongDanhGia.find(
          element => {
            return element.id == item.doi_tuong_danh_gia_id;
          }
        );
        if (doiTuongDanhGia) {
          item.ten_doi_tuong_danh_gia = doiTuongDanhGia.thong_tin_chung.ten;
        } else {
          item.ten_doi_tuong_danh_gia = "";
        }

        let luotCheckin = this.mData.dataDefault.listLuotCheckin.find(
          element => {
            return element.id == item.check_in_id
          }
        )

        if (luotCheckin) {
          item.thoi_diem_check_in = luotCheckin.thoi_diem_check_in;
        } else {
          item.thoi_diem_check_in = "";
        }
      });
      return data;
    },


    //click button
    fn_handle(type, scope, row) {
      if (type == "create") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-create"
        });
      }
      if (type == "update") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-update",
          params: { id: row.id }
        });
      }
      if (type == "detail") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-detail",
          params: { id: row.id }
        });
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.fn_delete(row.id);
          })
          .catch(() => {});
      }
      if (type == "disable") {
        this.$confirm(LanguageService.lang.user_disableConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.fn_disable(row.id, true);
          })
          .catch(() => {});
      }
      if (type == "openDisable") {
        this.$confirm(LanguageService.lang.user_openDisableConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.fn_disable(row.id, false);
          })
          .catch(() => {});
      }
    },

    //delete
    async fn_delete(id) {
      await DanhGiaLogApi.delete(id);
      this.fn_initTable();
    },

    //khóa tài khoản
    async fn_disable(id, disable) {
      await DanhGiaLogApi.disable(id, disable);
      this.fn_initTable();
    },

    //event table

    fn_tableSelectionChange(val) {
      var _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function(element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },

    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },
    // search
    fn_tableSearch() {
      if(this.mData.tableRules.dataSearch.value.gia_tri){
        this.mData.tableRules.dataSearch.value.gia_tri = this.mData.tableRules.dataSearch.value.gia_tri.trim();
      }

      this.$refs["myForm"].validate(async valid => {
        if (valid) {
          this.mData.tableRules.filters = MethodService.filterTable(JSON.stringify(this.mData.tableRules.dataSearch));
          this.mData.tableRules.offset = 0;
          this.mData.tableRules.sort = "";
          this.fn_initTable();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },

    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch = !this.mData.tableRules
        .showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-list",
        query: query
      });
    },

    fn_formatterDate(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "datetime");
    },

    fn_formatterNumber(cellValue, dec) {
      if (typeof cellValue == "number") {
        if (!(dec && typeof cellValue == "number")) dec = 0;
        return cellValue
          .toFixed(dec)
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + ",");
      }
    },

    async fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
      }
      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }
    }
  },

  //run after render view
  created() {
    this.fn_hashUrl();
  },
  mounted() {
    this.fn_initTable();
  }
};
</script>
